export default {
  'en': {
    'PREVIOUS_LABEL': 'Recent Tags',
    'PREVIOUS_TT': 'Choose from recently added tags',
    'PREVIOUS_PLACEHOLDER': 'Choose Tag',
    'TAG_NAME_LABEL': 'Name',
    'TAG_NAME_TT': 'The name of the tag',
    'TAG_NAME_PLACEHOLDER': 'Enter Tag Name',
    'TAG_VALUE_LABEL': 'Value',
    'TAG_VALUE_TT': 'The value of the tag <br/> (max 512 characters)',
    'TAG_VALUE_PLACEHOLDER': 'Enter Value',
    'ADD_ANNOTATION_BTN': 'Annotate'
  }
};